import React from 'react';
import {
  BrowserRouter as Router,
  useRoutes,
} from "react-router-dom";
import { getUserToken } from "../components/UserUtils";
import { pathname, redirectTo, redirectToLogin } from "../components/Utils";
import ForgottenPasswordPage from "../features/Pages/ForgottenPasswordPage";
import LoginPage from "../features/Pages/LoginPage";
import t from "../components/I18N/TranslateHelpers";
import { ResetPasswordPageType } from 'features/Entity/ResetPasswordFormData';

import { useAuth0 } from '@auth0/auth0-react';
import { getAuth0Config } from 'components/UtilsForAuth0';

  const auth0 = getAuth0Config();


const Auth0LoginRedirect = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();


  /*if(pathname === "/")
  {
    if(getUserToken())
    {
      redirectTo(t("url_dashboard", true));
    }
    else
    {
      redirectToLogin();
    }
  }*/
  React.useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      
      loginWithRedirect({
            authorizationParams: { prompt: "login" },
          });
    } else if (isAuthenticated) {
      // Redirection to dashboard if the user is already logged in via Auth0      
      redirectTo(t("url_dashboard", true));
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);
  return <div>Redirection vers Auth0...</div>;
};

const LoginSwitch = () => {
    if (auth0.isActive) {
        return <Auth0LoginRedirect />;
    }
    return <LoginPage />;
}

const AppLoginRoutes = () => useRoutes([
  { path: "/", element: <LoginSwitch /> }, //<LoginPage />
  { path: "/login", element: <LoginSwitch /> }, //<LoginPage />
  { path: "/forgotten-password", element: <ForgottenPasswordPage pageType={ResetPasswordPageType.ForgottenPassword} /> },
  { path: "/reset-password", element: <ForgottenPasswordPage pageType={ResetPasswordPageType.ResetPassword} /> },
  { path: "/activate-account", element: <ForgottenPasswordPage pageType={ResetPasswordPageType.ActivateAccount} /> },
]);

function AppLogin() {
  return (
    <Router>
      <AppLoginRoutes />
    </Router>
  );
}

export default AppLogin;
